import { updateKeyInStore } from 'App';
import {
  DividendsStateValues,
  TForeignDividendsIndicateCurrencyRow,
  TUsDividendsInRow,
  updateKey,
} from '../slice';

export const uploadFields: IBaseField<
  | keyof DividendsStateValues
  | keyof TUsDividendsInRow
  | keyof TForeignDividendsIndicateCurrencyRow
>[] = [
  {
    dependenciesTitle: 'US Dividends',
    name: 'pleaseUploadForm1099Div',
    label: 'Please upload Form 1099-DIV',
    type: 'upload',
    predicate: (value) =>
      value === 'Yes - US Dividends Only' ||
      value === 'Yes - Both US & Foreign Dividends',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
    dependentOn:
      'taxQuestionnaire.spouseIncome.dividends.values.didYouReceiveAnyDividendIncomeDuringTheFilingYear',
  },
];
